<template>
    <b-modal
        id="modal-create-download-link"
        ref="modal-create-download-link"
        centered
        ok-title="Aceptar"
        ok-variant="primary"
        cancel-title="Cancelar"
        title="Agregar Nuevo Enlace"
        :ok-disabled="disableOkButton"
        @ok="onCreate"
        @hidden="resetForm()"
    >
        <b-form id="hyperlink-form" @submit.stop.prevent="onSubmit()">
            <b-form-group
                id="input-group-download-link-name"
                label="*Nombre:"
                label-for="input-download-link-name"
            >
                <b-form-input
                    id="input-download-link-name"
                    v-model.trim="$v.form.name.$model"
                    name="name"
                    type="text"
                    required
                    placeholder="Nombre a mostrar"
                    :state="validateState('name')"
                    :disabled="formDisabled"
                />
                <b-form-invalid-feedback id="input-download-link-name-feedback">
                    <ul>
                        <li v-if="!$v.form.name.required">Este campo es requerido.</li>
                    </ul>
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
                id="input-group-download-link-url"
                label="*Dirección URL:"
                label-for="input-download-link-url"
            >
                <b-form-input
                    id="input-download-link-url"
                    v-model.trim="$v.form.url.$model"
                    name="url"
                    type="text"
                    required
                    placeholder="http://www.ciens.ucv.ve/ciens/"
                    :state="validateState('url')"
                    :disabled="formDisabled"
                />
                <b-form-invalid-feedback id="input-download-link-url-feedback">
                    <ul>
                        <li v-if="!$v.form.url.required">Este campo es requerido.</li>
                        <li v-if="!$v.form.url.url">No es una dirección URL válida.</li>
                    </ul>
                </b-form-invalid-feedback>
            </b-form-group>
        </b-form>
    </b-modal>
</template>

<script>
import { required, url } from 'vuelidate/lib/validators'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    name: 'HyperlinkCreateFormModal',
    data () {
        return {
            formDisabled: false,
            form: {
                name: '',
                url: ''
            }
        }
    },
    validations: {
        form: {
            name: {
                required
            },
            url: {
                required,
                url
            }
        }
    },
    computed: {
        ...mapState([
            'activeSite'
        ]),
        ...mapGetters([
            'getActiveSiteIdentifiers'
        ]),
        disableOkButton () {
            return this.formDisabled || this.$v.form.$invalid
        }
    },
    methods: {
        ...mapActions([
            'createSiteHyperlink',
            'readCourseSiteByAcademicPeriod'
        ]),
        validateState (name) {
            const { $dirty, $error } = this.$v.form[name]
            return $dirty ? !$error : null
        },
        async onCreate (bvModalEvt) {
            bvModalEvt.preventDefault() // Prevent modal from closing
            await this.onSubmit() // Trigger submit handler
        },
        resetForm () {
            this.form.name = ''
            this.form.url = ''
            this.$v.$reset()
        },
        async onSubmit () {
            let loader = null
            var payloadData
            try {
                this.formDisabled = true
                loader = this.$root.$loading.show()
                payloadData = { ...this.form, courseSiteId: this.activeSite.id }
                await this.createSiteHyperlink(payloadData)
                this.$root.successToast(`Enlace creado exitosamente.`)
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-create-download-link')
                })
                this.resetForm()
                // Reload the current active site data
                await this.readCourseSiteByAcademicPeriod({
                    courseCode: this.getActiveSiteIdentifiers.courseCode,
                    academicPeriod: this.getActiveSiteIdentifiers.academicPeriod
                })
            } catch (err) {
                console.log({ err: err })
                if (err.response && (err.response.status === 404 || err.response.status === 400)) {
                    this.$root.dangerToast('Datos incorrectos, vuelva a intentar.')
                } else {
                    this.$root.unknownErrorToast()
                }
            } finally {
                this.formDisabled = false
                loader.hide()
            }
        }
    }
}
</script>
